import { Dropdown } from '@contexts/dropdowns/types';
import { UsersDropdown } from '@services/dropdowns/types';

export const isManuallyAdded = (
  userId: string,
  foremanId: string,
  fieldUsers: Dropdown<UsersDropdown[]>,
) => {
  if (!foremanId || !fieldUsers.options.length) return true;

  return !fieldUsers.options
    .find((el) => el.id === foremanId)
    ?.crewMembers?.some((el) => el.id === userId);
};

interface SelectRecord {
  label: string;
  value: string;
}

export const sortByName = <T extends SelectRecord>(records: T[]) => {
  return records.sort((optionA: T, optionB: T) => {
    const nameA = optionA.label?.toLowerCase() || '';
    const nameB = optionB.label?.toLowerCase() || '';
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};
